
import { defineComponent } from "vue";
import { HomeTemplate } from "@/components/templates";

export default defineComponent({
  components: { HomeTemplate },
  /*Todos os componentes da página, teriam acesso aos dados 
  injetados no Vuex, aqui com o tag template.*/
  created() {
    //Chamada/requisição na API
  }
});
